import { Injectable } from '@angular/core';
import { AuthGuard } from '../auth.guard';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { SessionStateService } from '../services/session-state.service';
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    // intercept(req: HttpRequest<any>, next: HttpHandler): import("rxjs").Observable<HttpEvent<any>> {
    //     throw new Error("Method not implemented.");
    // }
    constructor(private session: SessionStateService, private authCheck: AuthGuard, private router: Router) {
        //...

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): import("rxjs").Observable<HttpEvent<any>> {

        const token: string = this.session.getToken();
        // if (request.url.indexOf("GetClientDetails") > -1) debugger;
        if (token) {
            if (this.authCheck.isTokenExpired()) {
                setTimeout(() => {
                    this.router.navigate(['/login']);
                    this.session.setToken(null);
                }, 0);
            }
            else {
                // console.log("token not expired");
            }
        }



        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', '' + token) });
        }

        // if (!request.headers.has('Content-Type')) {
        //     request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        // }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    //  console.log('event--->>>', event);
                }
                return event;
            }));
    }
}

